import Vue from "vue";

Vue.config.errorHandler = function(error, vm) {
  console.error(error);
  if (vm.$router.currentRoute.name !== "Error") {
    vm.$router.push({ name: "Error" });
  }
};
